// src/AppWrapper.jsx
import React, { useState, useEffect } from 'react';
import { Routes, Route, useNavigate, useLocation, Navigate } from 'react-router-dom';
import Navbar from './Navbar';
import Home from './Home';
import Footer from './Footer';
import About from './About';
import Cta from './Cta';
import Itwork from './Itwork';
import Contact from './Contact';
import Pricing from './Pricing';
import Dashboard from './components/Dashboard';
import Counselling from './components/Counselling';
import MyForm from './components/MyForm';
import Preloader from './components/Preloader';
import Map from './components/Map';
import Testimonial from './components/Testimonial';
import Slider from 'react-slick';
import PrivacyPolicy from './PrivacyPolicy';
import Terms from './Terms';
import RefundPolicy from './RefundPolicy';
import WhyChooseSection from './WhyChooseSection ';
import { DashboardUIProvider } from './context/DashboardUIContext';

// ---- NEW: IMPORT THE LOGIN PAGE COMPONENT ----
import LoginPage from './LoginPage'; // Make sure you have created this component

// --- UPDATED: Protected Route Component ---
const ProtectedRoute = ({ children }) => {
  const isLoggedIn = localStorage.getItem('isLoginTrue') === 'true';
  const location = useLocation(); // Get the current location

  if (!isLoggedIn) {
    // If not logged in, redirect to the /login page.
    // Pass the current location in state, so we can redirect back after login.
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If logged in, render the child component.
  return children;
};


function AppWrapper() {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // --- FIX: Scroll to top on every route change ---
    window.scrollTo(0, 0);

    // Your existing preloader logic
    setIsLoading(true);
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 400);
    return () => clearTimeout(timer);
  }, [location.pathname]);
  
  const handleLogout = () => {
    localStorage.removeItem('isLoginTrue');
    localStorage.removeItem('userId');
    localStorage.removeItem('currentUser');
    localStorage.removeItem('hasForm');
    navigate('/');
  };
  
  // ---- NEW: A function to handle successful login ----
  // This will be passed as a prop to your LoginPage
  const handleLogin = (userData, formExists) => {
      localStorage.setItem('isLoginTrue', 'true');
      localStorage.setItem('userId', userData.userId);
      localStorage.setItem('currentUser', JSON.stringify(userData));
      localStorage.setItem('hasForm', formExists ? 'true' : 'false');

      // Redirect user to the page they were trying to access, or to the dashboard/form
      const from = location.state?.from?.pathname || (formExists ? '/dashboard' : '/myform');
      navigate(from, { replace: true });
  };


  return (
    <DashboardUIProvider>
      {isLoading && <Preloader />}
      <div style={{ visibility: isLoading ? 'hidden' : 'visible' }}>
        <Navbar onLogout={handleLogout} />
        <main className="page-content-wrapper">
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/Footer" element={<Footer />} />
            <Route path="/About" element={<About />} />
            <Route path="/Cta" element={<Cta />} />
            <Route path="/Itwork" element={<Itwork />} />
            <Route path="/Contact" element={<Contact />} />
            <Route path="/Pricing" element={<Pricing />} />
            <Route path="/Map" element={<Map />} />
            <Route path="/Testimonial" element={<Testimonial />} />
            <Route path="/Slider" element={<Slider />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
            <Route path="/WhyChooseSection" element={<WhyChooseSection />} />
            
            {/* ---- NEW: Login Page Route ---- */}
            {/* The onLogin prop passes the handler function to your login form */}
            <Route path="/login" element={<LoginPage onLogin={handleLogin} />} />

            {/* Protected Routes - Now wrapped with the updated ProtectedRoute */}
            <Route path="/Dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/book-counselling" element={<ProtectedRoute><Counselling /></ProtectedRoute>} />
            <Route path="/myform" element={<ProtectedRoute><MyForm /></ProtectedRoute>} />

          </Routes>
        </main>
        {/* The Footer can be here or inside specific page components */}
        <Footer />
      </div>
    </DashboardUIProvider>
  );
}

export default AppWrapper;